module.exports = __webpack_public_path__ + "img/wanhai.91ead026.webp";